import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { QueryFlagLabels, QueryFlagTooltips, QueryFlags } from "../utils/types";
import Autocomplete from "./library/Autocomplete";
import { checkForMatch } from "../utils/misc";

interface QueryFlagsAutocompleteProps {
  onChange: (newSelected:QueryFlags[]) => void;
  reactRef: any;
  selected: QueryFlags[];
}
interface FilterProps {
  text: string
}

function QueryFlagsAutocomplete(props: QueryFlagsAutocompleteProps) {
  const labelKeyFunction = (option: QueryFlags) => {
    return QueryFlagLabels[option];
  }

  const filterQueryFlags = (option: QueryFlags, props: FilterProps) => {
    if (props.text == null || props.text.length === 0) return true;

    const searchString = (props.text as string).trim().toLowerCase();
    const searchStrings:string[] = searchString.split(" ");

    return checkForMatch(searchStrings, QueryFlagLabels[option].toLowerCase());
  }

  const handleCheckboxClick = (e:any, selectedValue:QueryFlags) => {
    e.stopPropagation();

    const selectedValues = props.selected ? [...props.selected, selectedValue] : [selectedValue];
    props.onChange(selectedValues);
  }

  const renderMenuItemChildren = (option: (QueryFlags)) => {
    const checkboxElement = (
      <Form.Check
        inline
        readOnly
        style={{ whiteSpace: "nowrap", margin: "0 5px", cursor: "pointer" }}
        type="checkbox"
        checked={props.selected.includes(option)}
        onClick={(e) => handleCheckboxClick(e, option)}
      />
    );

    const menuItem = (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <OverlayTrigger
          key={option}
          placement="auto"
          overlay={( props ) => {
            return (                        
              <Tooltip {...props} id={option}>
                {QueryFlagTooltips[option]}
              </Tooltip>
            );
          }
        }>
          <span>{checkboxElement}{QueryFlagLabels[option]}</span>
        </OverlayTrigger>
      </div>
    )

    return menuItem;
  };

  return (
    <Autocomplete
      id="queryFlagsAutocomplete"
      placeholder="Query Flags"
      reactKey="queryFlagsAutocomplete"
      labelKey={labelKeyFunction}
      filterBy={filterQueryFlags} 
      renderMenuItemChildren={renderMenuItemChildren}  
      onChange={props.onChange}
      options={Object.values(QueryFlags)}
      selected={props.selected}
      reactRef={props.reactRef}
      multiple
    />
  );
}

export default QueryFlagsAutocomplete;